import { translate as t } from "infrastructure/translate/localization";
import { displayRemoveSubsidyRecurrent } from "usecases/benefit-model/displays/allowance/display-remove-subsidy-recurrent";
import { displaySubsidyPage } from "usecases/benefit-model/displays/allowance/display-subsidy-page";
import { MUIBox, MUIGrid, tokens } from "@cobee/cobee-ui";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutline";
import BorderColorOutlinedIcon from "@material-ui/icons/BorderColorOutlined";
import { IconButton } from "@material-ui/core";
import { ReactComponent as MealIcon } from "v2/assets/icons/meal-benefit.svg";
import { ReactComponent as TransportIcon } from "v2/assets/icons/transport-benefit.svg";
import { ReactComponent as NurseryIcon } from "v2/assets/icons/nursery-benefit.svg";

export default function SubsidyCard({ benefitModel }: { benefitModel }) {
  const iconsDictionary = {
    "meal-benefit": {
      icon: <MealIcon />,
      translate: t("benefits-section.meal-benefit.meal"),
    },
    "transport-benefit": {
      icon: <TransportIcon />,
      translate: t("benefits-section.transport-benefit.transport"),
    },
    "nursery-benefit": {
      icon: <NurseryIcon />,
      translate: t("benefits-section.nursery-benefit.nursery"),
    },
  };

  return (
    <>
      {benefitModel.subsidy && (
        <MUIBox
          sx={{
            maxWidth: "58.75rem",
            marginTop: "32px",
            backgroundColor: tokens.palette.common.white,
            borderRadius: "24px",
            padding: "24px",
            boxShadow: "1px 1px 10px rgba(151, 151, 151, 0.2)",
          }}
        >
          <div>
            <MUIGrid
              container
              justifyContent="space-between"
              alignItem="center"
            >
              <MUIGrid item>
                <p
                  style={{
                    fontSize: "12px",
                    marginBottom: "4px",
                    color: "#6B6B6B",
                  }}
                >
                  {t("v2.common.recurrent-delivery")}
                </p>
              </MUIGrid>
              <MUIGrid item>
                <IconButton
                  onClick={() =>
                    displaySubsidyPage({
                      model: benefitModel,
                      recurrentSubsidy: true,
                      alertId: null,
                    })
                  }
                  size="small"
                  data-testid="edit-icon"
                  style={{ color: tokens.palette.secondary.main }}
                >
                  <BorderColorOutlinedIcon />
                </IconButton>
                <IconButton
                  onClick={() => displayRemoveSubsidyRecurrent(benefitModel)}
                  size="small"
                  data-testid="remove-icon"
                  style={{ color: tokens.palette.secondary.main }}
                >
                  <DeleteOutlineOutlinedIcon />
                </IconButton>
              </MUIGrid>
            </MUIGrid>
            <p
              style={{
                fontSize: "16px",
                lineHeight: "24px",
                fontWeight: "500",
                marginBottom: "28px",
              }}
            >
              {t("subsidy-section.next-recharge")}
            </p>

            <MUIGrid
              container
              justifyContent="space-between"
              alignItem="center"
            >
              {benefitModel.subsidy.generalParameters.map((sub) => {
                return (
                  <MUIGrid
                    item
                    key={sub.category}
                    xs={4}
                    sx={{
                      pr: 8,
                      pl: 0,
                      "&:nth-child(2)": {
                        px: 8,
                        borderRight: `solid 1px #CFDAE5`,
                        borderLeft: `solid 1px #CFDAE5`,
                      },
                      "&:nth-child(3)": {
                        pr: 0,
                        pl: 8,
                      },
                    }}
                  >
                    <MUIGrid container>
                      <MUIGrid
                        item
                        style={{
                          paddingBottom: "6px",
                        }}
                      >
                        <MUIGrid container alignItem="center">
                          <MUIGrid item>
                            {iconsDictionary[sub.category].icon}
                          </MUIGrid>
                          <MUIGrid item>
                            <span
                              style={{
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: "21px",
                                marginLeft: "8px",
                                color: tokens.palette.grey[900],
                              }}
                            >
                              {iconsDictionary[sub.category].translate}
                            </span>
                          </MUIGrid>
                        </MUIGrid>
                      </MUIGrid>
                    </MUIGrid>
                    <MUIGrid
                      item
                      style={{
                        paddingTop: "6px",
                        borderTop: "1px solid #CFDAE5",
                      }}
                    >
                      <MUIGrid
                        container
                        justifyContent="space-between"
                        alignItem="center"
                      >
                        <MUIGrid item>
                          <span
                            style={{
                              fontWeight: 400,
                              fontSize: "14px",
                              lineHeight: "21px",
                              color: tokens.palette.grey[700],
                            }}
                          >
                            {t("common-messages.amount")}
                          </span>
                        </MUIGrid>
                        <MUIGrid item>
                          {sub.days ? (
                            <span
                              style={{
                                fontWeight: 400,
                                fontSize: "14px",
                                lineHeight: "21px",
                                color: tokens.palette.grey[900],
                              }}
                            >
                              {(sub.amount.amountInCents / 100) * sub.days}{" "}
                              {sub.amount.currency}
                            </span>
                          ) : (
                            <span>
                              {sub.amount.amountInCents / 100}{" "}
                              {sub.amount.currency}
                            </span>
                          )}
                        </MUIGrid>
                      </MUIGrid>
                    </MUIGrid>
                  </MUIGrid>
                );
              })}
            </MUIGrid>
          </div>
        </MUIBox>
      )}
    </>
  );
}
